import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import Farm from '../interfaces/farm';
import Season from '../interfaces/season';
import { IStorageUsageData } from '../pages/document-storage';

export class FarmService extends HttpClient {
  show(farmId: string): Observable<Farm> {
    return this.get<Farm>(`/api/farms/${farmId}`);
  }

  update(farmId: string, farm: Farm): Observable<Farm> {
    return this.put<Farm>(`/api/farms/${farmId}`, farm);
  }

  seasons(farmId: string): Observable<Season[]> {
    return this.get<Season[]>(`/api/farms/${farmId}/seasons`);
  }

  getStorageUsage(farmId: string): Observable<IStorageUsageData> {
    return this.get(`/api/farms/${farmId}/storage-usage`);
  }
}
